/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum IntegrationCheckStatus {
  Pass = "Pass",
  Fail = "Fail",
  Warn = "Warn",
  Skipped = "Skipped",
}

export function instanceOfIntegrationCheckStatus(value: any): boolean {
  for (const key in IntegrationCheckStatus) {
    if (Object.prototype.hasOwnProperty.call(IntegrationCheckStatus, key)) {
      if (
        IntegrationCheckStatus[key as keyof typeof IntegrationCheckStatus] ===
        value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function IntegrationCheckStatusFromJSON(
  json: any,
): IntegrationCheckStatus {
  return IntegrationCheckStatusFromJSONTyped(json, false);
}

export function IntegrationCheckStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): IntegrationCheckStatus {
  return json as IntegrationCheckStatus;
}

export function IntegrationCheckStatusToJSON(
  value?: IntegrationCheckStatus | null,
): any {
  return value as any;
}

export function IntegrationCheckStatusToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): IntegrationCheckStatus {
  return value as IntegrationCheckStatus;
}
